export default __webpack_public_path__ + "static/media/icon-audio-mute.de53a589.svg";